import { EventTracking } from "@shared/services/event_tracking/events";
import { ListEntity, ListProductEntity } from "@shared/services/event_tracking/entities";
const { trackEvent } = EventTracking;

export const trackListSearch = query => {
  const entity: ListEntity = new ListEntity({ service: "list", query: query });
  trackEvent("list_search", entity);
};

export const trackListCreate = listId => {
  const entity: ListEntity = new ListEntity({ service: "list", listId: listId });
  trackEvent("list_create", entity);
};

export const trackListDelete = listId => {
  const entity: ListEntity = new ListEntity({ service: "list", listId: listId });
  trackEvent("list_delete", entity);
};

export const trackListUpdate = listId => {
  const entity: ListEntity = new ListEntity({ service: "list", listId: listId });
  trackEvent("list_update", entity);
};

export const trackListAdd = (listId, productId, productLineId, inventoryId, distributorId) => {
  const entity: ListProductEntity = new ListProductEntity({
    service: "list",
    listId: listId,
    product: productId,
    productLine: productLineId,
    inventoryId: inventoryId,
    distributor: distributorId,
  });

  trackEvent("list_add", entity);
};

export const trackListRemove = (listId, productId, productLineId, inventoryId, distributorId) => {
  const entity: ListProductEntity = new ListProductEntity({
    service: "list",
    listId: listId,
    product: productId,
    productLine: productLineId,
    inventoryId: inventoryId,
    distributor: distributorId,
  });
  trackEvent("list_remove", entity);
};
